import React from 'react';
import { File, Textarea } from 'components/ui/formik';
import styles from '../../../order.module.scss';

const Form = () => (
  <>
    <div className={styles.item}>
      <Textarea
        label="Причина изменения статуса"
        name="statusComment"
        placeholder="Оставьте комментарий"
      />
    </div>
    <div className={styles.item}>
      <File
        accept=".jpg, .jpeg, .png, .xlsx, .xls, .pdf"
        label="Приложить документ"
        name="file"
      />
    </div>
  </>
);

export default Form;
